// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_9MwrN"};